import { apiClient } from '../utils/api-client';
import type { SendsResponse } from '../types/send';

class SendsService {
  async getClimbSends(climbSlug: string): Promise<SendsResponse> {
    const response = await apiClient.get(`/api/climbs/${climbSlug}/sends`);
    return await response.json();
  }

  /**
   * Everything a person has sent, newest first. Whole by default — the stats
   * page does its sums on all of it — or one page of ten at a time when asked
   * for a `page`, with `meta.has_more` saying whether to ask for the next.
   */
  async getUserSends(userSlug: string, page?: number): Promise<SendsResponse> {
    const query = page ? `?page=${page}` : '';
    const response = await apiClient.get(`/api/users/${userSlug}/sends${query}`);
    return await response.json();
  }

  /**
   * Everything anyone has sent at a crag, newest first. Paged: a cliff open for
   * a decade has more ascents than one screen, and `meta.has_more` says whether
   * asking for the next page is worth it.
   */
  async getCragSends(cragSlug: string, page = 1): Promise<SendsResponse> {
    const response = await apiClient.get(`/api/crags/${cragSlug}/sends?page=${page}`);

    if (!response.ok) {
      throw new Error('Failed to fetch the crag’s ascents');
    }

    return await response.json();
  }
}

export const sendsService = new SendsService();
